<template lang="html">
  <div class="actions-panel">
    <span v-if="hint" class="hint">
      {{ hint }}
    </span>

    <div class="buttons-group">
      <button
        class="vcv-button gray iconed"
        :disabled="!isElementsSelected"
        @click="archiveAction"
        v-tooltip.top-center="$tr('common.iconTooltips.archiveSelectedVacancies')"
      >
        <i class="icon icon-archive"></i>
        <span>{{ $tr('vacancies.archive') }}</span>
      </button>

      <button
        class="vcv-button gray iconed"
        :disabled="!isElementsSelected"
        @click="removeAction"
        v-tooltip.top-center="$tr('common.iconTooltips.deleteSelectedVacancies')"
      >
        <i class="icon icon-garbage"></i>
        <span>{{ $tr('vacancies.delete.delete') }}</span>
      </button>
    </div>
  </div>

</template>

<script>
  import Pluralize from '@/mixins/pluralize'

  export default {
    name: 'action-panel',

    mixins: [
      Pluralize
    ],

    props: {
      listLength: {
        type: Number,
        default: 0
      },
      isElementsSelected: {
        type: Boolean,
        default: false
      },
      archiveAction: {
        type: Function,
        required: true
      },
      removeAction: {
        type: Function,
        required: true
      }
    },

    computed: {
      hint () {
        const count = this.listLength

        if (!count) {
          return ''
        }

        const start = this.$tc('common.selectedVacancies', count)
        const pluralized = this.pluralize(this.$tr('vacancies.vacancy', count))

        return `${start} ${count} ${pluralized}`
      }
    },

    beforeMount () {
      // Fetch company users to share link email list
      this.$store.dispatch('users/fetchUsersDropdown')
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/queries.scss';

  .actions-panel {
    display: flex;
    align-self: center;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;

    @include tablet {
      .hint {
        display: none;
      }
    }

    @include mobile {
      .hint {
        display: none;
      }
    }
  }
</style>
